export default "__VITE_ASSET__CbWFctmZ__"